import {
  Loading,
  MARKET_DATA_QUESTIONNAIRE_HEADER,
  MarketDataQuestionnaireDescription,
  MarketDataQuestionnaireForm,
  Section
} from '@tradingblock/components';
import React, { FunctionComponent, useEffect, useState } from 'react';

import { config } from '../clientConfig';

export const MobileMarketDataQuestionnaire: FunctionComponent<{}> = () => {
  const [accountId, setAccountId] = useState<number | null>(null);
  const [apiToken, setApiToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [failedToLoadMarketDataQuestionnaire, setFailedToLoadMarketDataQuestionnaire] = useState<boolean>(false);

  useEffect(() => {
    if (
      window &&
      window.ReactNativeWebView &&
      window.ReactNativeWebView.injectedObjectJson &&
      window.ReactNativeWebView.injectedObjectJson()
    ) {
      // This condition is for Android only. For some reason the key injectedObjectJson was
      // is not getting attached to the key ReactNativeWebView for iOS. For iOS I am using a custom key on the window
      // that triggers the condition below.
      // https://github.com/react-native-webview/react-native-webview/issues/3629
      const {
        apiToken: injectedApiTokenFromReactNativeWebView,
        accountId: injectedAccountIdFromReactNativeWebView
      } = JSON.parse(window.ReactNativeWebView.injectedObjectJson()) as { accountId?: number | null, apiToken?: string | null };

      if (!injectedApiTokenFromReactNativeWebView || !injectedAccountIdFromReactNativeWebView) {
        setFailedToLoadMarketDataQuestionnaire(true);
        window.ReactNativeWebView.postMessage('failed-to-load-market-data-questionnaire');
      } else {
        setAccountId(injectedAccountIdFromReactNativeWebView);
        setApiToken(injectedApiTokenFromReactNativeWebView);
      }
    } else if (window && window.ReactNativeWebView && window.ReactNativeWebViewData) {
      const {
        apiToken: injectedApiTokenFromReactNativeWebView,
        accountId: injectedAccountIdFromReactNativeWebView
      } = window.ReactNativeWebViewData as { accountId?: number | null, apiToken?: string | null };

      if (!injectedApiTokenFromReactNativeWebView || !injectedAccountIdFromReactNativeWebView) {
        setFailedToLoadMarketDataQuestionnaire(true);
        window.ReactNativeWebView.postMessage('failed-to-load-market-data-questionnaire');
      } else {
        setAccountId(injectedAccountIdFromReactNativeWebView);
        setApiToken(injectedApiTokenFromReactNativeWebView);
      }
    } else {
      setFailedToLoadMarketDataQuestionnaire(true);
    }

    setIsLoading(false);
  }, []);

  return (
    <main className="mobile-market-data-questionnaire">
      <Section>
        <div className="content">
          {isLoading && (<div className="loading-wrapper"><Loading /></div>)}

          {failedToLoadMarketDataQuestionnaire && !isLoading && (
            <div className="error-wrapper">
              <div className="error-content-wrapper">
                <i className="fal fa-exclamation-circle error m-1" />
                <p>There was an issue loading the market data questionnaire.</p>
              </div>
            </div>
          )}

          {accountId && apiToken && !isLoading && (
            <>
              <h1>{MARKET_DATA_QUESTIONNAIRE_HEADER}</h1>

              <MarketDataQuestionnaireDescription />

              <MarketDataQuestionnaireForm
                accountId={accountId}
                apiToken={apiToken}
                rootRestHubUrl={config.dashboard.tradingApi}
                onSubmissionSuccess={() =>
                  window &&
                  window.ReactNativeWebView &&
                  window.ReactNativeWebView.postMessage &&
                  window.ReactNativeWebView.postMessage('market-data-questionnaire-submission-success')
                }
              />
            </>
          )}
        </div>
      </Section>
    </main>
  );
};
